import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class EmployeeWorkingCalendarDay  {
    _originalTypeClassName = "zERP.BO.EmployeeWorkingCalendarDay";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
EmployeeWorkingCalendarDay.translate = translateService;
}
this.Date = null;
this.HoursWorked = 0;
this.Insured = false;
this.Overtimes = 0;
this.ContractHours = 0;
this.Holiday = null;
this.LeaveName = null;
this.EmployeeWorkingCalendarDayKey = null;
this._key = this.EmployeeWorkingCalendarDayKey = 0; 
}

static translate: TranslateService;
_key: any;
Date:any;
HoursWorked:any;
Insured:any;
Overtimes:any;
ContractHours:any;
Holiday:any;
LeaveName:any;
EmployeeWorkingCalendar:any;
Leave:any;
private _EmployeeWorkingCalendarDayKey:any;
get EmployeeWorkingCalendarDayKey(): any {
    return this._EmployeeWorkingCalendarDayKey;
  }
set EmployeeWorkingCalendarDayKey(value: any) {
    this._EmployeeWorkingCalendarDayKey = value;
    this._key = value;
  }
static setEmployeeWorkingCalendar = ($this, value) => {
var oldValue = $this.EmployeeWorkingCalendar;
$this.EmployeeWorkingCalendar = value;
if (value != null) {
if (oldValue != null) {
Domain.EmployeeWorkingCalendar.removeDays(oldValue, $this);
}
Domain.EmployeeWorkingCalendar.addDays(value, $this);
}
}
static setLeave = ($this, value) => {
var oldValue = $this.Leave;
$this.Leave = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.EmployeeWorkingCalendarDayKey == null || $this.EmployeeWorkingCalendarDayKey == 0;
            }


}